module.exports = __webpack_public_path__ + "media/images/faces/male/14-c989bd3ab263bf3155a22356a8c122ba.jpg";